/**
 * @module ol/ViewProperty
 */
/**
 * @enum {string}
 */
export default {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation',
};
//# sourceMappingURL=ViewProperty.js.map


// WEBPACK FOOTER //
// /~/ol/ViewProperty.js